import * as types from '../types';
import { IDunningApi } from '../contracts';
import { HttpApi } from './HttpApi';

export class DunningHttpApi extends HttpApi implements IDunningApi {
  async previewDunning(): Promise<types.DunningPreview> {
    const response = await this.http.get<types.APIResponse<types.DunningPreview>>('/dunning/preview');
    return response.data.data;
  }

  async runDunning(data: types.RunDunningRequest): Promise<types.DunningRunResult> {
    const response = await this.http.post<types.APIResponse<types.DunningRunResult>>('/dunning/run', data);
    return response.data.data;
  }

  async listDunningRuns(limit?: number): Promise<types.DunningRunSummary[]> {
    const response = await this.http.get<types.APIResponse<types.DunningRunSummary[]>>('/dunning/runs', {
      params: limit === undefined ? undefined : { limit },
    });
    return response.data.data;
  }

  async getDunningSteps(): Promise<types.DunningSteps> {
    const response = await this.http.get<types.APIResponse<types.DunningSteps>>('/dunning/steps');
    return response.data.data;
  }

  async replaceDunningSteps(data: types.ReplaceDunningStepsRequest): Promise<types.DunningSteps> {
    const response = await this.http.put<types.APIResponse<types.DunningSteps>>('/dunning/steps', data);
    return response.data.data;
  }

  async listInvoiceDunningNotices(invoiceId: string): Promise<types.DunningNotice[]> {
    const response = await this.http.get<types.APIResponse<types.DunningNotice[]>>(
      `/dunning/invoices/${encodeURIComponent(invoiceId)}/notices`
    );
    return response.data.data;
  }

  async setInvoiceDunningHold(invoiceId: string, hold: boolean): Promise<types.Invoice> {
    const response = await this.http.post<types.APIResponse<types.Invoice>>(
      `/invoices/${encodeURIComponent(invoiceId)}/dunning-hold`,
      { hold }
    );
    return response.data.data;
  }
}
